"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    if (knex.client.config.client !== 'sqlite3') {
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.text('success_msg').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.text('redirect_url').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.text('banner_image_url').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.text('logo_url').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW_COLUMNS, (table)=>{
            table.text('description').alter();
        });
    }
};
const down = async (knex)=>{
    if (knex.client.config.client !== 'sqlite3') {
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.string('success_msg').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.string('redirect_url').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.string('banner_image_url').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
            table.string('logo_url').alter();
        });
        await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW_COLUMNS, (table)=>{
            table.string('description').alter();
        });
    }
};
